import { lazy } from 'react';

export default {
  exact: false,
  name: 'GIMACpay Bill',
  protected: true,
  path: '/gimac-pay-bill',
  component: lazy(() => import('containers/Gimac/PayBills')),
};
